//import { API_URI } from "@/helpers/config";

export default class Artist {
    constructor(data) {
        Object.assign(this, data);
    }

    get url() {
        const model = this;
        return {name: 'artists', params: {artistSlug: model.slug}};
    }
    get slug() {
        const model = this;
        return `${model.name}`;
    }
}
